import { createColumnHelper } from '@tanstack/react-table';
import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Tag } from '@optimus-web/core';
import { compactArray } from '@mews/fp';
import { getBookablePeriodTextKey } from '@mews-commander/utils';
import { useService } from '@mews-commander/legacy-entities/src/utils/useService';
import { ServicePromotionTableActions } from './ServicePromotionTableActions';

const columnHelper = createColumnHelper<PromotedServiceAssignment>();

const BookablePeriod = ({ serviceId }: { serviceId: string }) => {
    const service = useService(serviceId);
    const textKey = service ? getBookablePeriodTextKey(service) : TextKey.Day;
    return lt(textKey);
};

export const useColumns = (
    canManageServiceConfiguration: boolean,
    openEditDialog: (data: PromotedServiceAssignment) => void
) =>
    compactArray([
        columnHelper.accessor('promotedServiceName', {
            id: 'linkedService',
            header: () => lt(TextKey.LinkedService),
        }),
        columnHelper.accessor('promotedServiceId', {
            header: () => lt(TextKey.BookablePeriod),
            cell: (props) => <BookablePeriod serviceId={props.getValue()} />,
        }),
        columnHelper.accessor('promotedResourceCategoryName', {
            header: () => lt(TextKey.ResourceCategory),
        }),
        columnHelper.accessor('promotedRateName', {
            header: () => lt(TextKey.Rate),
        }),
        columnHelper.accessor('isEnabled', {
            header: () => lt(TextKey.Status),
            cell: (props) =>
                props.getValue() ? (
                    <Tag outline variant="success" leadingIcon={IconName.Done}>
                        {lt(TextKey.Enabled)}
                    </Tag>
                ) : (
                    <Tag outline variant="basicBold" leadingIcon={IconName.Disable}>
                        {lt(TextKey.Disabled)}
                    </Tag>
                ),
        }),
        columnHelper.accessor('ordering', {
            header: () => lt(TextKey.Ordering),
        }),
        canManageServiceConfiguration
            ? columnHelper.display({
                  id: 'actions',
                  meta: { align: 'end' },
                  cell: (props) => (
                      <ServicePromotionTableActions
                          promotedService={props.row.original}
                          openEditDialog={openEditDialog}
                      />
                  ),
              })
            : null,
    ]);
